export default __webpack_public_path__ + "5a5a75adef6907135fff482e6022cb46.svg";